import { TabPanel, TabPanelLocation } from '@tabeeb/enums'
import { createAction } from 'redux-actions'
import { SessionPanelState } from '@tabeeb/modules/sessionTabs/reducers'

export const setNavbarDefaultState = createAction('SET_NAVBAR_DEFAULT_STATE')
export const resetNavbarState = createAction('RESET_NAVBAR_STATE')
export const switchPanel = createAction('SWITCH_PANEL', (panel: SessionPanelState, location: TabPanelLocation) => ({
  panel,
  location,
}))
export const expandPanel = createAction('EXPAND_PANEL', (panel: TabPanel) => ({ panel }))
export const collapsePanel = createAction('COLLAPSE_PANEL', (panel: TabPanel) => ({ panel }))
